export class RefreshToken {
  accessToken: string | undefined;
  refreshToken: string | undefined;
  tokenType?: string | undefined;
}
export class OAuthTokenResponse {
  access_token: string | undefined;
  refresh_token: string | undefined;
  expires_in: number | undefined;
  token_type?: string;
}
